module.exports = __webpack_public_path__ + "img/green-marker.f85dda86.svg";